import { render, staticRenderFns } from "./ComplianceCheckDetails.vue?vue&type=template&id=2fe05581&"
import script from "./ComplianceCheckDetails.vue?vue&type=script&lang=js&"
export * from "./ComplianceCheckDetails.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceCheckDetails.vue?vue&type=style&index=0&id=2fe05581&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports